const About = () => {
  return (
    <div style={{ maxWidth: 800, margin: '0 auto', padding: '24px', backgroundColor: '#fff', borderRadius: 8 }}>
      <h1 style={{ color: '#E1332D', marginBottom: 24 }}>关于NBA篮球博客</h1>
      <p style={{ fontSize: 16, lineHeight: 2, color: '#333' }}>
        本博客专注于NBA赛事分析、球星动态、赛季预测等内容，旨在为广大篮球爱好者提供优质的NBA相关资讯。
      </p>
      <p style={{ fontSize: 16, lineHeight: 2, color: '#333' }}>
        我们的内容团队由资深NBA评论员、数据分析师组成，力求以客观、专业的视角解读每一场比赛、每一位球星。
      </p>
      <p style={{ fontSize: 16, lineHeight: 2, color: '#333' }}>
        版权声明：本博客所有内容仅用于交流学习，未经许可不得商用。
      </p>
    </div>
  );
};

export default About;